
import SectionHead from "./ChartSectionHead";
import SectionContent from "./ChartSectionContent";
import * as Actions from "actions/ChartPageActions";

export default {
	SectionHead,
	SectionContent,
	Actions,
};



/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/index.js
 **/